export const storeShoppingCart = (shoppingCartString: string) => {
  localStorage.setItem("shoppingCart", shoppingCartString);
}